/**
 * BizAoiProduceResultType - create / updateGeometry / updateBasic / delete 四个 mutation 的公共返回。
 */

/** gql fragment 文本 (直接内联进各 mutation 的 selection, 不用 fragment 语法以免命名冲突)。 */
export const PRODUCE_RESULT_FIELDS = `
      success
      errorCode
      errorMessage
      conflictAoiIds
      conflictTruncated
      aoiId
      zipcode
      centerLatitude
      centerLongitude
      parentAoiId
      asyncTaskId
`;

export interface BizAoiProduceResult {
    success: boolean;
    /** INVALID_GEOMETRY / VERTEX_LIMIT / AREA_LIMIT / OVERLAP_SAME_LEVEL / CROSS_OTHER_LEVEL_EDGE
     *  / CENTER_OUT_OF_ZIPCODE / ZIPCODE_LOOKUP_FAILED / LOCK_TIMEOUT / AOI_NOT_FOUND */
    errorCode: string | null;
    errorMessage: string | null;
    /** 冲突面 (重叠 / 交叉时) - 前端标红高亮。 */
    conflictAoiIds: number[] | null;
    conflictTruncated: boolean | null;
    aoiId: number | null;
    zipcode: string | null;
    centerLatitude: number | null;
    centerLongitude: number | null;
    parentAoiId: number | null;
    /** 非空 = 有后台异步挂载任务 (前端只提示一句"已提交", 不跟踪进度)。 */
    asyncTaskId: number | null;
}
